/**
 * © 2025 Indikin.online. All rights reserved.
 * Made with ❤️ by YalaCoder.
 *
 * Custom Hook and Context for Social Authentication
 *
 * --- REWRITE SUMMARY ---
 * - This file is now the single source for the context object and the hook.
 * - It creates and exports `SocialAuthContext` using `createContext`.
 * - It exports the `useSocialAuth` custom hook that consumes the context.
 * - This pattern satisfies the `react-refresh/only-export-components` rule.
 */
import { createContext, useContext } from 'react';

// Create and export the context object from this non-component file.
export const SocialAuthContext = createContext(null);

export const useSocialAuth = () => {
  const context = useContext(SocialAuthContext);
  if (context === null) {
    throw new Error('useSocialAuth must be used within a SocialAuthProvider');
  }
  return context;
};
